const applyOnboardingIntroChatResponse = (payload) => ({ type: 'onboardingApplyIntroChatResponse', payload });

export default applyOnboardingIntroChatResponse;
